import { Module } from 'vuex-smart-module';
import CertificatesListActions from './actions';
import CertificatesListGetters from './getters';
import CertificatesListMutations from './mutations';
import CertificatesListState from './state';

export default new Module({
  state: CertificatesListState,
  mutations: CertificatesListMutations,
  actions: CertificatesListActions,
  getters: CertificatesListGetters,
});
